import axios from 'axios';

import { IPlanning } from '@/shared/model/planning.model';

const baseApiUrl = 'api/plannings';
const baseMobileApiUrl = 'api/mobile/plannings';

export default class PlanningService {
  public find(id: number): Promise<IPlanning> {
    return new Promise<IPlanning>((resolve, reject) => {
      axios
        .get(`${baseApiUrl}/${id}`)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public retrieve(): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .get(baseApiUrl)
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public delete(id: number): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .delete(`${baseApiUrl}/${id}`)
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public create(entity: IPlanning): Promise<IPlanning> {
    return new Promise<IPlanning>((resolve, reject) => {
      axios
        .post(`${baseApiUrl}`, entity)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public update(entity: IPlanning): Promise<IPlanning> {
    return new Promise<IPlanning>((resolve, reject) => {
      axios
        .put(`${baseApiUrl}/${entity.id}`, entity)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public getPlanningFile(id: number): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .get(`${baseApiUrl}/${id}/planning-file`, {
          responseType: 'json', // Expecting GeoJSON content directly
        })
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  // Bản cho trang /mobile/*: đi qua /api/mobile để backend xác thực bằng token. Gọi thẳng
  // /api/plannings thì app mobile (không có phiên web) nhận 401 và bị đẩy khỏi bản đồ.
  public getPlanningFileMobileApi(projectId: number, accessToken: string): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .get(`${baseMobileApiUrl}/${projectId}/planning-file`, {
          responseType: 'json',
          headers: {
            Authorization: `${accessToken}`,
          },
        })
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }
}
